{
  "countryOrRegion": "Quốc gia/Khu vực",
  "defaultCountry": "Việt Nam",
  "familyName": "Họ",
  "givenName": "Tên",
  "identityNumber": "Số giấy tờ tùy thân",
  "identityPhotos": "Ảnh giấy tờ tùy thân",
  "identityPhotoFront": "Mặt trước giấy tờ tùy thân",
  "identityPhotoBack": "Mặt sau giấy tờ tùy thân",
  "identityPhotoHint": "Đảm bảo thấy đầy đủ viền giấy tờ, ảnh rõ nét và ánh sáng đồng đều. Mỗi ảnh không quá 5MB; hỗ trợ JPG, JPEG và PNG.",
  "next": "Tiếp theo",
  "previous": "Quay lại",
  "identityVerification": "Xác minh danh tính",
  "confirmLeave": "Xác nhận rời đi",
  "leaveWarning": "Bạn có chắc muốn rời đi không? Thông tin bạn đã nhập sẽ bị mất.",
  "cancel": "Hủy",
  "recordingInstructions": "Cầm giấy tờ tùy thân cạnh bạn trong video và đọc số xác minh. Sau khi đọc xong, hãy hướng giấy tờ về phía máy ảnh trong 1–3 giây và tránh phản chiếu. Thông tin trên giấy tờ và video phải rõ ràng, nếu không việc xét duyệt có thể không được chấp nhận.",
  "cameraPermissionRequired": "Chưa bật quyền truy cập máy ảnh hoặc micrô. Bạn có thể thay đổi trong Cài đặt.",
  "processingVideo": "Đang xử lý video…",
  "recordAgain": "Quay lại video",
  "submitForReview": "Gửi xét duyệt",
  "unableToRecordVideo": "Không thể quay video",
  "unableToPlayVideo": "Không thể phát video",
  "dataLoadFailed": "Không thể tải dữ liệu",
  "resetFailed": "Không thể đặt lại",
  "reviewPending": "Đang xét duyệt",
  "reviewPendingDescription": "Tải lên thành công. Chúng tôi sẽ xét duyệt nội dung bạn gửi sớm nhất có thể.",
  "reviewApproved": "Đã xét duyệt",
  "reviewApprovedDescription": "Chúc mừng! Danh tính của bạn đã được xét duyệt.",
  "reviewRejected": "Không được xét duyệt",
  "reviewRejectedDescription": "Rất tiếc, việc xét duyệt của bạn không thành công vì:",
  "fillInAgain": "Điền lại",
  "uploadFailed": "Tải lên không thành công. Vui lòng thử lại sau.",
  "identityAlreadyVerified": "Số giấy tờ tùy thân này đã được xác minh",
  "verificationFailed": "Xác minh danh tính không thành công",
  "uploadIdentityPhotos": "Vui lòng tải lên ảnh mặt trước và mặt sau giấy tờ tùy thân",
  "invalidImageFormat": "Định dạng ảnh không hợp lệ",
  "imageTooLarge": "Kích thước ảnh vượt quá giới hạn 5MB",
  "unableToReadImage": "Không thể đọc ảnh đã chọn",
  "prepareVideo": "Hãy chuẩn bị quay video xác minh danh tính. Bảo đảm kết nối mạng ổn định, thời lượng không quá 15 giây và nên dùng Wi‑Fi để tránh lỗi tải lên.",
  "startRecording": "Bắt đầu quay",
  "uploading": "Đang tải lên. Vui lòng chờ.",
  "retryUpload": "Thử tải lên lại"
}
